import CopyClipBoard from './_copyToClipboard.svelte';

const copyToClipboard = (text: string) => {
	const component = new CopyClipBoard({
		target: document.body,
		props: { text },
	});
	component.$destroy();
};

export default copyToClipboard;
